import type { StaffOidcAuthzConfig } from '@sbe-spinoff-client/staff-oidc-auth';
import type { StaffMeDto } from './generated-api/sbe-sms/models';

/** `staff/auth/me` 응답(orval 생성 `StaffMeDto`)에서 권한을 읽는 방법 — `provideStaffOidcAuth({ authz })` 에 넘긴다. */
export const smsStaffAuthz: StaffOidcAuthzConfig = {
  hasScope: (me, scope) => (me as StaffMeDto).scopes.includes(scope),
  canManageStaff: (me) => (me as StaffMeDto).canManageStaff,
  staffId: (me) => (me as StaffMeDto).staffId,
  invitationStatus: (me) => (me as StaffMeDto).invitationStatus,
};
